export default "__VITE_ASSET__a1ab5758__"